const zh = {
  nav: {
    home: "\u9996\u9875",
    browse: "\u6d4f\u89c8\u5a5a\u793c",
    browseWeddings: "\u6d4f\u89c8\u5a5a\u793c",
    dashboard: "\u4eea\u8868\u677f",
    messages: "\u6d88\u606f",
    profile: "\u4e2a\u4eba\u8d44\u6599",
    login: "\u767b\u5f55",
    register: "\u6ce8\u518c",
    logout: "\u9000\u51fa",
    admin: "\u7ba1\u7406",
  },
  landing: {
    hero: {
      badge: "#1 \u5a5a\u793c\u4f53\u9a8c\u5e73\u53f0",
      title: "\u4f53\u9a8c\u4e16\u754c\u5404\u5730\u96be\u5fd8\u7684\u5a5a\u793c",
      subtitle: "WEDVAYA \u5c06\u65b0\u4eba\u4e0e\u5bfb\u6c42\u771f\u5b9e\u6587\u5316\u4f53\u9a8c\u7684\u65c5\u884c\u8005\u8054\u7cfb\u8d77\u6765\u3002\u6210\u4e3a\u7279\u6b8a\u65f6\u523b\u7684\u4e00\u90e8\u5206 \u2013 \u4f5c\u4e3a\u4e3b\u4eba\u6216\u5ba2\u4eba\u3002",
      cta_host: "\u4f5c\u4e3a\u4e3b\u4eba\u5f00\u59cb",
      cta_guest: "\u53d1\u73b0\u5a5a\u793c",
    },
    trust: {
      freeRegistration: "\u514d\u8d39\u6ce8\u518c",
      securePayment: "\u5b89\u5168\u652f\u4ed8",
      gdprCompliant: "\u7b26\u5408GDPR",
    },
    stats: {
      weddings: "\u5a5a\u793c",
      worldwide: "\u5168\u7403",
      guests: "\u5ba2\u4eba",
      matched: "\u5df2\u5339\u914d",
      countries: "\u56fd\u5bb6",
      represented: "\u5df2\u4ee3\u8868",
      rating: "\u8bc4\u5206",
      average: "\u5e73\u5747",
    },
    features: {
      title: "\u4e3a\u4ec0\u4e48\u9009\u62e9WEDVAYA\uff1f",
      subtitle: "\u6211\u4eec\u8ba9\u5206\u4eab\u96be\u5fd8\u7684\u5a5a\u793c\u4f53\u9a8c\u53d8\u5f97\u7b80\u5355\u548c\u5b89\u5168\u3002",
      secure: {
        title: "\u5b89\u5168\u652f\u4ed8",
        desc: "\u6240\u6709\u4ea4\u6613\u7531Stripe\u4fdd\u62a4\u3002\u60a8\u7684\u8d44\u91d1\u5728\u6d3b\u52a8\u4e3e\u884c\u524d\u662f\u5b89\u5168\u7684\u3002",
      },
      verified: {
        title: "\u8ba4\u8bc1\u6863\u6848",
        desc: "\u53ef\u9009\u7684\u8eab\u4efd\u9a8c\u8bc1\uff0c\u589e\u5f3a\u4e3b\u4eba\u548c\u5ba2\u4eba\u4e4b\u95f4\u7684\u4fe1\u4efb\u3002",
      },
      global: {
        title: "\u5168\u7403\u6d3b\u52a8",
        desc: "\u4ece\u6258\u65af\u5361\u7eb3\u7684\u6d6a\u6f2b\u5a5a\u793c\u5230\u5370\u5ea6\u7684\u4f20\u7edf\u5e86\u5178\u3002",
      },
      contact: {
        title: "\u76f4\u63a5\u8054\u7cfb",
        desc: "\u9884\u8ba2\u540e\uff0c\u60a8\u53ef\u4ee5\u76f4\u63a5\u4e0e\u4e3b\u4eba\u6c9f\u901a\u3002",
      },
      gdpr: {
        title: "\u7b26\u5408GDPR",
        desc: "\u60a8\u7684\u6570\u636e\u662f\u5b89\u5168\u7684\u3002\u6211\u4eec\u4e25\u683c\u9075\u5b88\u6b27\u6d32\u6570\u636e\u4fdd\u62a4\u6307\u5357\u3002",
      },
      instant: {
        title: "\u5373\u65f6\u9884\u8ba2",
        desc: "\u5feb\u901f\u7533\u8bf7\u6d41\u7a0b\u300248\u5c0f\u65f6\u5185\u6536\u5230\u56de\u590d\u3002",
      },
    },
    howItWorks: {
      title: "\u5982\u4f55\u8fd0\u4f5c",
      subtitle: "\u53ea\u9700\u51e0\u6b65\u5373\u53ef\u83b7\u5f97\u96be\u5fd8\u4f53\u9a8c",
      step1: {
        title: "\u5bfb\u627e\u5a5a\u793c",
        desc: "\u6d4f\u89c8\u6211\u4eec\u5728\u5168\u7403\u7684\u72ec\u7279\u5a5a\u793c\u9009\u62e9\u3002",
      },
      step2: {
        title: "\u53d1\u9001\u7533\u8bf7",
        desc: "\u5411\u65b0\u4eba\u4ecb\u7ecd\u81ea\u5df1\uff0c\u544a\u8bc9\u4ed6\u4eec\u4f60\u4e3a\u4ec0\u4e48\u60f3\u53c2\u52a0\u3002",
      },
      step3: {
        title: "\u786e\u8ba4\u4e0e\u4ed8\u6b3e",
        desc: "\u83b7\u5f97\u6279\u51c6\u540e\uff0c\u5b89\u5168\u5728\u7ebf\u4ed8\u6b3e\u3002\u53ea\u6709\u8fd9\u6837\u624d\u80fd\u9884\u7559\u4f4d\u7f6e\u3002",
      },
      step4: {
        title: "\u5e86\u795d",
        desc: "\u4f53\u9a8c\u771f\u5b9e\u7684\u5a5a\u793c\uff0c\u521b\u9020\u7ec8\u8eab\u56de\u5fc6\u3002",
      },
    },
    howItWorksHost: {
      step1: {
        title: "\u53d1\u5e03\u60a8\u7684\u5a5a\u793c",
        desc: "\u4e3a\u60a8\u7684\u5a5a\u793c\u521b\u5efa\u4e00\u4e2a\u5305\u542b\u6240\u6709\u91cd\u8981\u7ec6\u8282\u7684\u6863\u6848\u3002",
      },
      step2: {
        title: "\u5ba1\u67e5\u7533\u8bf7",
        desc: "\u67e5\u770b\u611f\u5174\u8da3\u7684\u5ba2\u4eba\u7684\u8d44\u6599\u3002",
      },
      step3: {
        title: "\u83b7\u5f97\u62a5\u916c",
        desc: "\u6d3b\u52a8\u7ed3\u675f\u540e\uff0c\u60a8\u81ea\u52a8\u83b7\u5f9785%\u7684\u6536\u5165\u3002",
      },
      step4: {
        title: "\u4e00\u8d77\u5e86\u795d",
        desc: "\u4e0e\u6765\u81ea\u4e16\u754c\u5404\u5730\u7684\u4eba\u5206\u4eab\u60a8\u7684\u7279\u522b\u65e5\u5b50\u3002",
      },
    },
    tabs: {
      forGuests: "\u9002\u5408\u5ba2\u4eba",
      forHosts: "\u9002\u5408\u4e3b\u4eba",
    },
    testimonials: {
      title: "\u6211\u4eec\u7684\u793e\u533a\u600e\u4e48\u8bf4",
      subtitle: "\u6765\u81ea\u771f\u5b9e\u4eba\u7684\u771f\u5b9e\u4f53\u9a8c",
    },
    featured: {
      title: "\u63a8\u8350\u5a5a\u793c",
      subtitle: "\u53d1\u73b0\u4e16\u754c\u5404\u5730\u7684\u72ec\u7279\u5e86\u5178",
      viewAll: "\u67e5\u770b\u5168\u90e8",
      perPerson: "\u6bcf\u4eba",
    },
    cta: {
      title: "\u51c6\u5907\u597d\u4f60\u7684\u96be\u5fd8\u4f53\u9a8c\u4e86\u5417\uff1f",
      subtitle: "\u52a0\u5165WEDVAYA\u793e\u533a",
      description: "\u65e0\u8bba\u60a8\u60f3\u4e0e\u4e16\u754c\u5206\u4eab\u60a8\u7684\u5a5a\u793c\u8fd8\u662f\u5bfb\u6c42\u72ec\u7279\u7684\u65c5\u884c\u4f53\u9a8c \u2013 WEDVAYA\u8ba9\u4e00\u5207\u6210\u4e3a\u53ef\u80fd\u3002",
      button: "\u514d\u8d39\u6ce8\u518c",
      becomeHost: "\u7acb\u5373\u6210\u4e3a\u4e3b\u4eba",
      learnMore: "\u4e86\u89e3\u66f4\u591a",
    },
    press: {
      title: "\u5a92\u4f53\u62a5\u9053",
    },
  },
  auth: {
    login: {
      title: "\u6b22\u8fce\u56de\u6765",
      email: "\u7535\u5b50\u90ae\u4ef6",
      password: "\u5bc6\u7801",
      button: "\u767b\u5f55",
      noAccount: "\u6ca1\u6709\u8d26\u6237\uff1f",
      register: "\u7acb\u5373\u6ce8\u518c",
      forgotPassword: "\u5fd8\u8bb0\u5bc6\u7801\uff1f",
    },
    register: {
      title: "\u521b\u5efa\u8d26\u6237",
      name: "\u5168\u540d",
      email: "\u7535\u5b50\u90ae\u4ef6",
      password: "\u5bc6\u7801",
      role: "\u6211\u60f3...",
      roleHost: "\u4e3e\u529e\u5a5a\u793c",
      roleGuest: "\u53c2\u52a0\u5a5a\u793c",
      terms: "\u6211\u63a5\u53d7\u6761\u6b3e\u548c\u9690\u79c1\u653f\u7b56",
      button: "\u6ce8\u518c",
      hasAccount: "\u5df2\u7ecf\u6ce8\u518c\uff1f",
      login: "\u7acb\u5373\u767b\u5f55",
    },
    forgotPassword: {
      title: "\u5fd8\u8bb0\u5bc6\u7801\uff1f",
      description: "\u8f93\u5165\u60a8\u7684\u90ae\u7bb1\uff0c\u6211\u4eec\u5c06\u53d1\u9001\u91cd\u7f6e\u94fe\u63a5",
      submit: "\u53d1\u9001\u91cd\u7f6e\u94fe\u63a5",
      sent: "\u8bf7\u68c0\u67e5\u60a8\u7684\u90ae\u7bb1",
      sentDescription: "\u5982\u679c\u8be5\u90ae\u7bb1\u5b58\u5728\u8d26\u6237\uff0c\u60a8\u5c06\u6536\u5230\u5bc6\u7801\u91cd\u7f6e\u94fe\u63a5\u3002",
      backToLogin: "\u8fd4\u56de\u767b\u5f55",
    },
    resetPassword: {
      title: "\u91cd\u7f6e\u5bc6\u7801",
      description: "\u8bf7\u8f93\u5165\u60a8\u7684\u65b0\u5bc6\u7801",
      newPassword: "\u65b0\u5bc6\u7801",
      confirmPassword: "\u786e\u8ba4\u5bc6\u7801",
      submit: "\u91cd\u7f6e\u5bc6\u7801",
      success: "\u5bc6\u7801\u5df2\u91cd\u7f6e\uff01",
      successDesc: "\u60a8\u7684\u5bc6\u7801\u5df2\u6210\u529f\u91cd\u7f6e\u3002\u60a8\u73b0\u5728\u53ef\u4ee5\u767b\u5f55\u3002",
      goToLogin: "\u524d\u5f80\u767b\u5f55",
      mismatch: "\u5bc6\u7801\u4e0d\u5339\u914d",
      tooShort: "\u5bc6\u7801\u81f3\u5c11\u9700\u89816\u4e2a\u5b57\u7b26",
    },
    verification: {
      verifying: "\u6b63\u5728\u9a8c\u8bc1\u60a8\u7684\u90ae\u7bb1...",
      pleaseWait: "\u8bf7\u7a0d\u7b49",
      successTitle: "\u90ae\u7bb1\u5df2\u9a8c\u8bc1\uff01",
      success: "\u60a8\u7684\u90ae\u7bb1\u5df2\u6210\u529f\u9a8c\u8bc1\uff01",
      errorTitle: "\u9a8c\u8bc1\u5931\u8d25",
      noToken: "\u672a\u63d0\u4f9b\u9a8c\u8bc1\u4ee4\u724c",
      goToLogin: "\u524d\u5f80\u767b\u5f55",
      tryAgain: "\u91cd\u65b0\u6ce8\u518c",
    },
  },
  dashboard: {
    host: {
      title: "\u4e3b\u4eba\u4eea\u8868\u677f",
      myWeddings: "\u6211\u7684\u5a5a\u793c",
      applications: "\u7533\u8bf7",
      earnings: "\u6536\u5165",
      messages: "\u6d88\u606f",
      createWedding: "\u521b\u5efa\u5a5a\u793c",
      noWeddings: "\u5c1a\u672a\u521b\u5efa\u5a5a\u793c",
    },
    guest: {
      title: "\u5ba2\u4eba\u4eea\u8868\u677f",
      myApplications: "\u6211\u7684\u7533\u8bf7",
      browseWeddings: "\u6d4f\u89c8\u5a5a\u793c",
      messages: "\u6d88\u606f",
      profile: "\u6211\u7684\u8d44\u6599",
    },
  },
  wedding: {
    search: {
      title: "\u5bfb\u627e\u5a5a\u793c",
      location: "\u4f4d\u7f6e",
      date: "\u65e5\u671f",
      price: "\u4ef7\u683c",
      search: "\u641c\u7d22",
      reset: "\u91cd\u7f6e",
      noResults: "\u672a\u627e\u5230\u5a5a\u793c",
    },
    card: {
      slots: "\u540d\u989d\u53ef\u7528",
      perGuest: "\u6bcf\u4f4d\u5ba2\u4eba",
      apply: "\u7533\u8bf7",
      viewDetails: "\u67e5\u770b\u8be6\u60c5",
    },
    detail: {
      about: "\u5173\u4e8e\u6b64\u5a5a\u793c",
      host: "\u4e3b\u4eba",
      location: "\u4f4d\u7f6e",
      date: "\u65e5\u671f",
      dresscode: "\u7740\u88c5\u8981\u6c42",
      price: "\u6bcf\u4f4d\u5ba2\u4eba\u4ef7\u683c",
      slots: "\u53ef\u7528\u540d\u989d",
      apply: "\u7acb\u5373\u7533\u8bf7",
      alreadyApplied: "\u5df2\u7533\u8bf7",
    },
    create: {
      title: "\u521b\u5efa\u65b0\u5a5a\u793c",
      titleField: "\u6807\u9898",
      description: "\u63cf\u8ff0",
      location: "\u4f4d\u7f6e",
      country: "\u56fd\u5bb6",
      date: "\u65e5\u671f",
      dresscode: "\u7740\u88c5\u8981\u6c42",
      price: "\u6bcf\u4f4d\u5ba2\u4eba\u4ef7\u683c",
      slots: "\u5ba2\u4eba\u6570\u91cf",
      currency: "\u8d27\u5e01",
      submit: "\u521b\u5efa\u5a5a\u793c",
    },
  },
  application: {
    status: {
      pending: "\u5f85\u5904\u7406",
      approved: "\u5df2\u6279\u51c6",
      rejected: "\u5df2\u62d2\u7edd",
    },
    payment: {
      pending: "\u5f85\u4ed8\u6b3e",
      paid: "\u5df2\u4ed8\u6b3e",
      pay: "\u7acb\u5373\u652f\u4ed8",
    },
    approve: "\u6279\u51c6",
    reject: "\u62d2\u7edd",
  },
  review: {
    title: "Write a Review",
    description: "Share your experience with",
    ratingLabel: "How would you rate your experience?",
    rating1: "Poor",
    rating2: "Fair",
    rating3: "Good",
    rating4: "Very Good",
    rating5: "Excellent",
    commentLabel: "Your Review",
    optional: "optional",
    commentPlaceholder: "Tell others about your experience...",
    for: "Review for",
    submit: "Submit Review",
    success: "Review submitted successfully!",
    error: "Failed to submit review",
    selectRating: "Please select a rating",
    noReviews: "No reviews yet",
    received: "Reviews Received",
    averageRating: "Average Rating",
    writeReview: "Write Review",
    reviewed: "Reviewed",
    completedWedding: "This wedding has been completed. You can now write a review.",
  },

  messages: {
    title: "\u6d88\u606f",
    noMessages: "\u6ca1\u6709\u6d88\u606f",
    placeholder: "\u5199\u6d88\u606f...",
    send: "\u53d1\u9001",
  },
  admin: {
    title: "\u7ba1\u7406\u4eea\u8868\u677f",
    stats: {
      users: "\u7528\u6237",
      hosts: "\u4e3b\u4eba",
      guests: "\u5ba2\u4eba",
      weddings: "\u5a5a\u793c",
      activeWeddings: "\u6d3b\u8dc3\u5a5a\u793c",
      applications: "\u7533\u8bf7",
      revenue: "\u603b\u6536\u5165",
      platformEarnings: "\u5e73\u53f0\u6536\u5165",
    },
    tabs: {
      overview: "\u6982\u89c8",
      users: "\u7528\u6237",
      weddings: "\u5a5a\u793c",
      transactions: "\u4ea4\u6613",
    },
    actions: {
      ban: "\u7981\u6b62",
      unban: "\u53d6\u6d88\u7981\u6b62",
      feature: "\u63a8\u8350",
      unfeature: "\u53d6\u6d88\u63a8\u8350",
    },
  },
  common: {
    loading: "\u52a0\u8f7d\u4e2d...",
    error: "\u53d1\u751f\u9519\u8bef",
    success: "\u6210\u529f",
    save: "\u4fdd\u5b58",
    cancel: "\u53d6\u6d88",
    delete: "\u5220\u9664",
    edit: "\u7f16\u8f91",
    back: "\u8fd4\u56de",
    next: "\u4e0b\u4e00\u6b65",
    language: "\u8bed\u8a00",
    currency: "\u8d27\u5e01",
  },
  footer: {
    about: "\u5173\u4e8e",
    privacy: "\u9690\u79c1",
    terms: "\u6761\u6b3e",
    contact: "\u8054\u7cfb",
    description: "\u5168\u7403\u96be\u5fd8\u5a5a\u793c\u4f53\u9a8c\u5e73\u53f0\u3002",
    copyright: "\u00a9 2024 WEDVAYA. \u4fdd\u7559\u6240\u6709\u6743\u5229\u3002",
  },
  notifications: {
    title: "\u901a\u77e5",
    empty: "\u6682\u65e0\u901a\u77e5",
    markAllRead: "\u5168\u90e8\u6807\u4e3a\u5df2\u8bfb",
  },
  chat: {
    conversations: "\u5bf9\u8bdd",
    search: "\u641c\u7d22\u5bf9\u8bdd...",
    noConversations: "\u6682\u65e0\u5bf9\u8bdd",
    selectConversation: "\u9009\u62e9\u5bf9\u8bdd",
    selectConversationDesc: "\u4ece\u5217\u8868\u4e2d\u9009\u62e9\u4e00\u4e2a\u5bf9\u8bdd\u5f00\u59cb\u804a\u5929",
    online: "\u5728\u7ebf",
    offline: "\u79bb\u7ebf",
    connecting: "\u8fde\u63a5\u4e2d...",
    noMessages: "\u6682\u65e0\u6d88\u606f",
    startConversation: "\u5f00\u59cb\u5bf9\u8bdd\u5427\uff01",
    placeholder: "\u8f93\u5165\u6d88\u606f...",
    you: "\u4f60",
  },
  cookies: {
    title: "\u6211\u4eec\u4f7f\u7528Cookie",
    description: "\u6211\u4eec\u4f7f\u7528Cookie\u6765\u6539\u5584\u60a8\u7684\u4f53\u9a8c\u3001\u5206\u6790\u6d41\u91cf\u548c\u8fdb\u884c\u8425\u9500\u3002",
    acceptAll: "\u5168\u90e8\u63a5\u53d7",
    rejectAll: "\u5168\u90e8\u62d2\u7edd",
    customize: "\u81ea\u5b9a\u4e49",
    settingsTitle: "Cookie\u8bbe\u7f6e",
    functional: "\u529f\u80fd\u6027Cookie",
    functionalDesc: "\u7f51\u7ad9\u6b63\u5e38\u8fd0\u884c\u6240\u5fc5\u9700\u7684\u3002",
    analytics: "\u5206\u6790Cookie",
    analyticsDesc: "\u5e2e\u52a9\u6211\u4eec\u4e86\u89e3\u8bbf\u95ee\u8005\u5982\u4f55\u4e0e\u7f51\u7ad9\u4e92\u52a8\u3002",
    marketing: "\u8425\u9500Cookie",
    marketingDesc: "\u7528\u4e8e\u6295\u653e\u4e2a\u6027\u5316\u5e7f\u544a\u3002",
    saveSettings: "\u4fdd\u5b58\u8bbe\u7f6e",
  },
};

export default zh;
